export const UseAuthorizationHeader = Object.freeze({
  ALWAYS: 'always',
  NEVER: 'never',
  ONLY_FOR_LOGGED_IN: 'onlyForLoggedIn'
});